import '.b4{position:relative;}.ssr-plugin'
import '.ii{width:64px;}.ssr-plugin'
import '.ij{height:64px;}.ssr-plugin'
import '.au{flex-shrink:0;}.ssr-plugin'
import '.c6{position:absolute;}.ssr-plugin'
import '.ik{bottom:-4px;}.ssr-plugin'
import '.hg{right:-4px;}.ssr-plugin'
import '.f8{border-radius:50%;}.ssr-plugin'
import '.il{border:2px solid var(--palette-white);}.ssr-plugin'
import '.a3{overflow:hidden;}.ssr-plugin'
import '.im{width:32px;}.ssr-plugin'
import '.in{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="b4 ii ij au"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="c6 ik hg f8 il a3 im in"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
